/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable-next-line react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Paper,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Box
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ColoredLinearProgress from '../../../utils/coloredLinearProgress/ColoredLinearProgress';
import EnhancedTableHead from './EnhancedTableHead';
import ReceptionsTableLoader from './ReceptionsTableLoader';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  }
});

const getStyles = (reception, comparative) => {
  if (reception.state.code === 'checked') {
    if (comparative.expectedQuantity > comparative.actualQuantity) {
      return {
        backgroundColor: '#f99'
      };
    }
    if (comparative.expectedQuantity < comparative.actualQuantity) {
      return {
        backgroundColor: '#ffcd99'
      };
    }
  }
  return {};
};

const Rows = (reception, stock) => {
  const aggregateComparative = reception.comparative.map(value => {
    const findedProduct = stock.find(product =>
      product.barcodeValues.includes(value.barcodeValue)
    );
    return {
      ...value,
      ...findedProduct
    };
  });
  return aggregateComparative.map((value, index) => {
    const quantityPercentage =
      (value.actualQuantity * 100) / value.expectedQuantity;

    return (
      <TableRow
        hover
        style={{ cursor: 'pointer', ...getStyles(reception, value) }}
        tabIndex={-1}
        key={index}
      >
        <TableCell align="left">{value.reference}</TableCell>
        <TableCell align="left">{value.name || '-'}</TableCell>
        <TableCell align="left">{value.color || '-'}</TableCell>
        <TableCell align="left">{value.size || '-'}</TableCell>
        <TableCell align="left">{value.barcodeValue}</TableCell>
        <TableCell align="left">
          <Box>
            {value.actualQuantity || '0'} / {value.expectedQuantity || '0'}
          </Box>
          <Box mt={0.5}>
            <ColoredLinearProgress value={quantityPercentage} />
          </Box>
        </TableCell>
      </TableRow>
    );
  });
};

/*
 * Tableau d'affichage comparatif entre une l'article réceptionné
 * et l'article attendu
 *
 * @param {Object} classes                        classes style
 * @param {{Object}} reception                    Object contenant le détail de la réception
 * @param {Boolean} loading                       Indique si les requêtes sont terminer
 */
const EnhancedTable = ({ classes, reception, loading, stock }) => (
  <Paper className={classes.root}>
    <div className={classes.tableWrapper}>
      <Table className={classes.table} aria-labelledby="tableTitle">
        <EnhancedTableHead loading={loading} />
        {loading ? (
          <ReceptionsTableLoader />
        ) : (
          <TableBody>{Rows(reception, stock)}</TableBody>
        )}
      </Table>
    </div>
  </Paper>
);

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  stock: PropTypes.array.isRequired,
  reception: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  loading: state.receptions.loadingReception,
  stock: state.init.stock
});

export default connect(mapStateToProps)(withStyles(styles)(EnhancedTable));
